import Immutable from 'immutable';

export const State = Immutable.fromJS({
  password: '',
  confirmPassword: '',
  errMessage: '',
  isReset: false
});
